import { put, takeLatest } from "redux-saga/effects";
import {
  deleteOAuthClientFailure,
  deleteOAuthClientRequest,
  deleteOAuthClientSuccess,
  fetchOAuthClientUsersFailure,
  fetchOAuthClientUsersRequest,
  fetchOAuthClientUsersSuccess,
  fetchOAuthClientsFailure,
  fetchOAuthClientsRequest,
  fetchOAuthClientsSuccess,
  revokeOAuthClientUserFailure,
  revokeOAuthClientUserRequest,
  revokeOAuthClientUserSuccess
} from "../features/oauthClientsSlice";
import { deleteOAuthDynamicClient, getOAuthDynamicClientUsers, getOAuthDynamicClients, revokeOAuthDynamicClientUser } from "../../services/oauthClients";

function* fetchOAuthClients(action: ReturnType<typeof fetchOAuthClientsRequest>) {
  try {
    const data = yield getOAuthDynamicClients(action.payload);
    if (data?.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(fetchOAuthClientsSuccess(data.Data || data));
  } catch (error: any) {
    yield put(fetchOAuthClientsFailure(error.message));
  }
}

function* fetchOAuthClientUsers(action: ReturnType<typeof fetchOAuthClientUsersRequest>) {
  try {
    const data = yield getOAuthDynamicClientUsers(action.payload.serverId, action.payload.clientId);
    if (data?.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(fetchOAuthClientUsersSuccess(data.Data || data));
  } catch (error: any) {
    yield put(fetchOAuthClientUsersFailure(error.message));
  }
}

function* deleteOAuthClient(action: ReturnType<typeof deleteOAuthClientRequest>) {
  try {
    const data = yield deleteOAuthDynamicClient(action.payload.serverId, action.payload.clientId);
    if (data?.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(deleteOAuthClientSuccess({ clientId: action.payload.clientId, message: action.payload.successMessage }));
  } catch (error: any) {
    yield put(deleteOAuthClientFailure(error.message));
  }
}

function* revokeOAuthClientUser(action: ReturnType<typeof revokeOAuthClientUserRequest>) {
  try {
    const data = yield revokeOAuthDynamicClientUser(action.payload.serverId, action.payload.clientId, action.payload.uid);
    if (data?.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(revokeOAuthClientUserSuccess({ uid: action.payload.uid }));
  } catch (error: any) {
    yield put(revokeOAuthClientUserFailure(error.message));
  }
}

export function* watchOAuthClientsSaga() {
  yield takeLatest(fetchOAuthClientsRequest.type, fetchOAuthClients);
  yield takeLatest(fetchOAuthClientUsersRequest.type, fetchOAuthClientUsers);
  yield takeLatest(deleteOAuthClientRequest.type, deleteOAuthClient);
  yield takeLatest(revokeOAuthClientUserRequest.type, revokeOAuthClientUser);
}
